import { render, staticRenderFns } from "./cepRouterView.vue?vue&type=template&id=6b97a4fc&scoped=true&"
import script from "./cepRouterView.vue?vue&type=script&lang=js&"
export * from "./cepRouterView.vue?vue&type=script&lang=js&"
import style0 from "./cepRouterView.vue?vue&type=style&index=0&id=6b97a4fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97a4fc",
  null
  
)

export default component.exports